import cn from "classnames";

const InfoBox = ({ label, active, styles }) => (
  <div className={cn(styles.infoBox, { [styles.grey]: !active })}>{label}</div>
);

export default InfoBox;
